import { Activity } from "src/app/entities/Activity";
import { TimeRecord } from "src/app/entities/timeRecord";

export class TimeRecordWithChildrenDto extends TimeRecord {
	Activities: Activity[];

	constructor(TimeRecord: TimeRecord, Activities: Activity[]) {
		super(TimeRecord);
		this.Activities = Activities;
}
}
